import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import Cache from 'i18next-localstorage-cache';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import { getUserInformation } from '../components/Login/loginService';

const webclient = localStorage.getItem('x-olympia-client') || String(process.env.REACT_APP_CLIENT_NAME);
const options = {
    loadPath: process.env.REACT_APP_API_URL + 'locales/{{lng}}?client=' + webclient.toLocaleLowerCase()
};

const config = {
    backend: options,
    fallbackLng: 'en',
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    fallbackNS: 'translations',
    interpolation: {
        escapeValue: false, // not needed for react!!
    },
    react: {
        wait: true
    },
    cache: {
        enabled: true,
        expirationTime: 7*24*60*60*1000,
    }
};

/**
* Por si el usuario ya esta logueado y hace F5 o cierra y abre el browser.
* Si no esta logueado el usuario va caer en el fallbackLng.
* */
let user = getUserInformation();
let language = user ? user.user_detail.language.toLowerCase() : process.env.REACT_APP_DEFAULT_LANGUAGE;
if (language) config.lng = language;

const i18instance = i18n.use(Backend).use(LanguageDetector).use(reactI18nextModule).use(Cache).init(config, (err, t) => {
    if (err) return console.log('something went wrong loading', err);
    return t;
});

i18n.on('failedLoading', function(lng, ns, msg) { alert('failed'); });

export default i18instance;


// WEBPACK FOOTER //
// ./src/services/i18n.js